import React, { Component } from "react";
import { AppCard, DataTableToolbar, PageLayout } from "../components/ui";
import MerchantTariffsComponent from "./Merchants/MerchantTariffs";
import ExtendedDataTable from "../components/ExtendedDataTable";
import { ProductCode } from "../models/ProductCode";
import tariffApiService from "../services/api/tariff/TariffApiService";
import { Column } from "primereact/column";
import { numberFilterMatchModeOptions, stringFilterMatchModeOptions } from "./Paginator";
import { SearchRequestBaseModel, SortOrderType } from "../models/SearchRequestModel";
import { Banknote } from "lucide-react";
import { storageService } from "../services/StorageService";
import Currencies from "./Currencies";

interface TariffState {
    productCodes: ProductCode[];
    isLoading: boolean;
    totalProductCodes: number;
    merchantId: number;
}

export default class Tariffs extends Component<Record<string, never>, TariffState> {
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
        super(props);

        this.state = {
            productCodes: [],
            isLoading: false,
            totalProductCodes: 0,
            merchantId: Number(storageService.getSelectedMerchantId()),
        };
    }

    loadProductCodes = async (searchResult: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });
        const result = await tariffApiService.getProductCodes(searchResult);
        this.setState({ productCodes: result.data, totalProductCodes: result.totalCount });
        this.setState({ isLoading: false });
    };

    renderProductCodesTableHeader = (hasActiveFilters: boolean) => <DataTableToolbar onClear={() => this.dataTable!.reset()} hasActiveFilters={hasActiveFilters} />;

    render() {
        return (
            <PageLayout heading="Tariffs and Currencies" icon={Banknote}>
                <AppCard className="mb-3">
                    <AppCard.Body>
                        {/* <MerchantTariffsComponent merchantId={""} /> */}
                        <Currencies merchantId={this.state.merchantId} />
                    </AppCard.Body>
                </AppCard>
                <AppCard className="mb-3">
                    <AppCard.Header title="Product Codes" />
                    <AppCard.Body className="!p-0">
                        <ExtendedDataTable
                            header={this.renderProductCodesTableHeader}
                            ref={(ref) => (this.dataTable = ref)}
                            value={this.state.productCodes}
                            loading={this.state.isLoading}
                            totalRecords={this.state.totalProductCodes}
                            onChange={this.loadProductCodes}
                            defaultSortField={"id"}
                            defaultSortOrder={SortOrderType.Descending}
                        >
                            <Column {...({ alwaysVisible: true } as any)} field="id" header="Id" filterMatchModeOptions={numberFilterMatchModeOptions} />
                            <Column  {...({ alwaysVisible: true } as any)} field="productId" header="Product Id" filterMatchModeOptions={numberFilterMatchModeOptions} />
                            <Column
                                field="productCode"
                                header="Produtct Code"
                                {...({ alwaysVisible: true } as any)}
                                filterMatchModeOptions={stringFilterMatchModeOptions}
                            />
                            <Column
                                field="productCodeDescription"
                                header="Product Code Description"
                                filterMatchModeOptions={stringFilterMatchModeOptions}
                            />
                            <Column field="currencyId" header="Currency Id" filterMatchModeOptions={numberFilterMatchModeOptions} />
                            <Column
                                field="currencyCode"
                                header="Currency Code"
                                filterMatchModeOptions={stringFilterMatchModeOptions}
                            />
                            <Column
                                field="currencyDescription"
                                header="Currency Description"
                                filterMatchModeOptions={stringFilterMatchModeOptions}
                            />
                        </ExtendedDataTable>
                    </AppCard.Body>
                </AppCard>
            </PageLayout>
        );
    }
}
